import * as React from "react";
// import { createRoot } from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./assets/styles/main.scss";
import "./assets/fonts/fonts.css";
import "./assets/icons/style.css";
import { render } from "react-dom";

// const root = createRoot(document.getElementById("root"));

render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
